export default "__VITE_ASSET__B10s_dWA__"